import FeaturesComponent from "./FeaturesComponent";

const FeaturesSection = ({ id }: any) => {
  return <FeaturesComponent id={id} />;
};

export default FeaturesSection;
